import chartTransformations from '../charts';

var serializeOutputSettings = function serializeOutputSettings(widgetType, chartSettings) {
  switch (widgetType) {
    case 'heatmap':
      return chartTransformations.heatmap.serializeOut(chartSettings);

    case 'choropleth':
      return chartTransformations.choropleth.serializeOut(chartSettings);

    case 'donut':
    case 'pie':
      return chartTransformations.circular.serializeOut(chartSettings);

    case 'funnel':
      return chartTransformations.funnel.serializeOut(chartSettings);

    case 'metric':
      return chartTransformations.metric.serializeOut(chartSettings);

    case 'line':
    case 'area':
      return chartTransformations.line.serializeOut(chartSettings);

    case 'bar':
      return chartTransformations.bar.serializeOut(chartSettings);

    case 'table':
      return chartTransformations.table.serializeOut(chartSettings);

    case 'gauge':
      return chartTransformations.gauge.serializeOut(chartSettings);

    default:
      return {};
  }
};

export default serializeOutputSettings;